import { render, staticRenderFns } from "./bracket-winners.vue?vue&type=template&id=e3a720d8&scoped=true&"
import script from "./bracket-winners.vue?vue&type=script&lang=js&"
export * from "./bracket-winners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a720d8",
  null
  
)

export default component.exports